// lingland-frontend/src/pages/TermsPage.js
import React from 'react';
import { useTranslation } from 'react-i18next';
import SEO from '../components/SEO';
import useIntersectionObserver from '../hooks/useIntersectionObserver';
import './LegalPages.css';

function TermsPage() {
    const { t } = useTranslation();
    const [headerRef, isHeaderVisible] = useIntersectionObserver();

    return (
        <>
            <SEO
                title={t('terms_header_title')}
                description={t('terms_header_subtitle')}
                url="/regulamin"
            />
            <section ref={headerRef} className={`page-header-section section-bg-white animate-on-scroll ${isHeaderVisible ? 'is-visible' : ''}`}>
                <div className="container text-center">
                    <h1>{t('terms_header_title')}</h1>
                    <p className="subtitle">{t('terms_header_subtitle')}</p>
                </div>
            </section>

             <section className="legal-content-section section-bg-light-gray">
                 <div className="container content-narrow">
                     <div className="legal-text">
                        <h2>{t('terms_section1_title')}</h2>
                        <ol>
                            <li>{t('terms_section1_li1')}</li>
                            <li>{t('terms_section1_li2')}</li>
                            <li>{t('terms_section1_li3')}</li>
                            <li>{t('terms_section1_li4')}</li>
                        </ol>
                        <h2>{t('terms_section2_title')}</h2>
                        <ol>
                            <li>{t('terms_section2_li1')}</li>
                            <li>{t('terms_section2_li2')}</li>
                            <li>{t('terms_section2_li3')}</li>
                            <li>{t('terms_section2_li4')}</li>
                        </ol>
                        <h2>{t('terms_section3_title')}</h2>
                        <ol>
                            <li>{t('terms_section3_li1')}</li>
                            <li>{t('terms_section3_li2')}</li>
                            <li>{t('terms_section3_li3')}</li>
                            <li>{t('terms_section3_li4')}</li>
                            <li>{t('terms_section3_li5')}</li>
                            <li>{t('terms_section3_li6')}</li>
                        </ol>
                        <h2>{t('terms_section4_title')}</h2>
                         <ol>
                            <li>{t('terms_section4_li1')}</li>
                            <li>{t('terms_section4_li2')}</li>
                            <li>{t('terms_section4_li3')}</li>
                            <li>{t('terms_section4_li4')}</li>
                         </ol>
                        <h2>{t('terms_section5_title')}</h2>
                         <ol>
                            <li>{t('terms_section5_li1')}</li>
                            <li>{t('terms_section5_li2')}</li>
                            <li>{t('terms_section5_li3')}</li>
                            <li>{t('terms_section5_li4')}</li>
                         </ol>
                        <h2>{t('terms_section6_title')}</h2>
                        <ol>
                            <li>{t('terms_section6_li1')}</li>
                            <li>{t('terms_section6_li2')}</li>
                            <li>{t('terms_section6_li3')}</li>
                            <li>{t('terms_section6_li4')}</li>
                        </ol>
                        <h2>{t('terms_section7_title')}</h2>
                        <ol>
                            <li>{t('terms_section7_li1')}</li>
                            <li>{t('terms_section7_li2')}</li>
                        </ol>
                        <h2>{t('terms_section8_title')}</h2>
                        <ol>
                            <li>{t('terms_section8_li1')}</li>
                        </ol>
                        <h2>{t('terms_section9_title')}</h2>
                        <ol>
                            <li>{t('terms_section9_li1')}</li>
                            <li>{t('terms_section9_li2')}</li>
                            <li>{t('terms_section9_li3')}</li>
                        </ol>
                        <h2>{t('terms_section10_title')}</h2>
                        <ol>
                            <li>{t('terms_section10_li1')}</li>
                            <li>{t('terms_section10_li2')}</li>
                            <li>{t('terms_section10_li3')}</li>
                            <li>{t('terms_section10_li4')}</li>
                        </ol>
                     </div>
                 </div>
            </section>
        </>
    );
}

export default TermsPage;